module.exports = __webpack_public_path__ + "img/other-login.bf44c622.png";